import { render, staticRenderFns } from "./Contactus.vue?vue&type=template&id=1bf1042c"
import script from "./Contactus.vue?vue&type=script&lang=js"
export * from "./Contactus.vue?vue&type=script&lang=js"
import style0 from "./Contactus.vue?vue&type=style&index=0&id=1bf1042c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserCountry: require('/root/workspace/web-company_Yo6Q/components/userLogin/userCountry.vue').default})
